// extracted by mini-css-extract-plugin
module.exports = {"card":"MarketingCard-module--card--2B6Hj","image":"MarketingCard-module--image--dorPq","card_body":"MarketingCard-module--card_body--2s1T7"};